<template lang="pug">
  v-flex(xs12 md4)
    div.headline {{ isEditingAction ? 'Editing an Action' : 'Adding an Action' }}
    div.subheading {{ campaignName }}
    v-flex.pt-5.pr-0.pb-0.pl-0(xs8)
      summary-list(
        :items="summaryValues"
        v-model="selectedItem"
        :editDisabled="editDisabled"
      )
</template>
<script>
import SummaryList from '@/Core/components/SummaryList';

export default {
  components: { SummaryList },

  data() {
    return {
      selectedItem: this.value,
    };
  },

  props: {
    /**
     * Controls whether the edit button is disabled or not
     */
    editDisabled: Boolean,
    /**
     * The name of the desired campaign
     */
    campaignName: String,
    /**
     * The array of objects that will be displayed on the summary liset
     */
    summaryValues: Array,
    /**
     * Boolean whether the user is in edit action mode or create action.
     */
    isEditingAction: Boolean,
    /**
     * The current selection that the user is currently in
     */
    value: String,
  },

  watch: {
    selectedItem(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.selectedItem = value;
    },
  },
};
</script>
